<template>
  <div style="background: rgb(8, 33, 64);min-height:100%" class=" display_column_between"
    :style="{ 'background': (templateModel != null ? templateModel.background : '#000000') }">
    <img class="banner-img" v-show="templateModel != null && templateModel.topPictureUrl != ''"
      :src="templateModel.topPictureUrl">
    <div class="channel-list-box">
      <!-- 板块 -->
      <div class="menu" v-for="(item, index) in templateModel.detaillist" :key="index"
        :style="{ 'background': 'linear-gradient(to right,' + (templateModel != null ? templateModel.color : '#000000') + ',transparent)' }">
        <img class="logo" v-show="item.logoUrl != null && item.logoUrl != ''" :src="item.logoUrl">
        <p class="title">{{ item.mainTitle }}</p>
        <p class="time" v-show="item.subtitle != ''">
          <i class="iconfont" style="color:#082140;opacity:0.4;">|</i>
          <span>{{ item.subtitle }}</span>
        </p>
        <a href="javascript:0" class="btn" @click="liveclk(item)"
          style="border:1px solid #0081c9;color:#0081c9;box-shadow:0 0 10px #0081c9;">{{ item.buttonText }}</a>
      </div>

    </div>
    <img class="bottom-img" v-show="templateModel!=null && templateModel.bottomPictureUrl"
      :src="templateModel.bottomPictureUrl">
  </div>
</template>

<script>
export default {
  name: "channelList",
  data() {
    return {
      Id: 0,//直播列表id
      templateModel: {},
      type: 0,  //1目睹2获得场景
      mtgId: 0
    }
  },
  methods: {
    //直播按钮事件
    liveclk(item) {
      // if (this.type == 1) {
      const { href } = this.$router.resolve({
        path: '/muduLiveMobile?',
        query: {
          id: item.liveID,
          mid: this.mtgId,
          back: encodeURIComponent(window.location.href)
        }
      });
      window.open(href, '_blank');
      // } else {
      //   const { href } = this.$router.resolve({
      //     path: '/huodeLive?',
      //     query: {
      //       id: item.liveID,
      //       mid: this.mtgId,
      //       back: encodeURIComponent(window.location.href)
      //     }
      //   });
      //   window.open(href, '_blank');
      // }

    },
    //获取直播模板列表
    GetLiveTemplateList() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetLiveTemplateList', {
        Id: parseInt(this.Id),
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          _this.templateModel = data;
          document.title = res.data.data.title || '全科医学网'
          this.$h5weixinshare.WeiXinShare(data.wechatSharingTitle, window.location.href, data.wechatSharingInfo, data.wechatSharingPictureUrl);
        }
      });
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    toF() {
      this.$router.push({
        path: '/meetingMobile',
        query: {
          mid: this.$route.query.mid
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    let userAgent = navigator.userAgent;

    if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
      sessionStorage.setItem('mobile_channelList', location.href); // 用于ios分享
    }

    next();
  },
  created() {
    if (this.isMobile()) {
      // 验证是否登录
      // if (!localStorage.getItem('ResData')) return this.$message.warning('请先登录');
      let _this = this
      _this.Id = this.$route.query.Id
      //1目睹2获得场景
      _this.type = this.$route.query.type
      if (this.$route.query.mid != '' && this.$route.query.mid != null) {
        this.mtgId = this.$route.query.mid;
      }
    } else {
      this.$router.push({
        path: '/channelList',
        query: {
          Id: this.$route.query.Id,
          type: this.$route.query.type,
          mid: this.mtgId
        }
      });
    }
  },
  mounted() {
    //获取模板列表
    this.GetLiveTemplateList();
    window.addEventListener("popstate", () => {
      this.toF()
    });
  },
  destroyed() {
    window.removeEventListener('popstate', this.toF);
  }
}
</script>
 

<style scoped>
img {
  width: 100%;
}

.menu {
  position: relative;
  margin: 1rem;
  padding: 1px;
  height: 5rem;
}

.menu .logo {
  float: left;
  margin: 1rem;
  width: 3rem;
  height: 3rem;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.menu .title {
  margin-top: 1rem;
  margin-left: 1.6rem;
  margin-bottom: 0.2rem;
  line-height: 1.8rem;
  font-size: 16px;
  color: #f3f5ff;
  margin-right: 5rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.menu .btn {
  position: absolute;
  display: inline-block;
  right: 10px;
  top: 50px;
  margin-top: -1.425rem;
  width: 60px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 14px;
  color: #6babff;
  border: 1px solid #6babff;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  border-radius: 1.5rem;
}

a {
  text-decoration: none;
}

.menu .time {
  position: relative;
  margin-left: 1.4rem;
  margin-right: 8.3rem;
  line-height: 1.2;
  overflow: hidden;
}

.menu .time i {
  position: absolute;
  left: 0;
  display: inline-block;
  font-size: 13px;
  color: #713a9c;
  vertical-align: top;
}

.iconfont {
  font-family: 'iconfont' !important;
  cursor: pointer;
  font-style: normal;
  font-size: 16px;
}

.menu .time span {
  display: inline-block;
  width: 100%;
  padding-left: 1rem;
  font-size: 12px;
  color: #fff;
  opacity: 0.6;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.channel-list-box {
  flex: 1;
}
</style>
 


